import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rating',
  imports: [],
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss'
})
export class RatingComponent {
  @Input() rating: any;

  /**
   * Author: Harshita
   * The function `setRating` sets the rating property of an object to a given number and logs the
   * rating value.
   * @param {number} number - The `number` parameter in the `setRating` function is used to specify the
   * rating value that will be assigned to the `rating` property of the object or class instance.
   */
  setRating(number:number){
    this.rating=number
    console.log("rating",this.rating);
  }

}
